import { render } from "./Leads.vue?vue&type=template&id=ea3a78aa&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=ea3a78aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3a78aa"]])

export default __exports__